export default "__VITE_ASSET__D9yocpE1__"